<template>
    <v-app-bar app dark class="app-style" height="70px">

      <v-tooltip
        v-for="(tab, i) in navTabs()"
        :key="tab.to"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="tab.disabled"
            :to="tab.to"
            icon
            color="white"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark>{{ tab.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ tab.label }}</span>
      </v-tooltip>

      <template v-if="isRedactorRoute && configUID">
        <v-divider vertical></v-divider>

        <div class="ac__header-info">
          <div class="ac__header-info-item">
            <div class="ac__header-info-item-title">
              <v-icon small class="ml-1">mdi-cog</v-icon>
              <span class="mr-1">Config ID:</span>
            </div>

            <span>{{ configUID }}</span>
          </div>

          <div v-if="globalUID" class="ac__header-info-item">
            <div class="ac__header-info-item-title">
              <v-icon small class="ml-1">mdi-earth</v-icon>
              <span class="mr-1">Global ID:</span>
            </div>

            <span>{{ globalUID }}</span>
          </div>

          <div class="ac__header-info-item">
            <div class="ac__header-info-item-title">
              <v-icon small class="ml-1">mdi-map-marker</v-icon>
              <span class="mr-1">Map ID:</span>
            </div>

            <span>{{ mapID || 'No Map ID added' }}</span>
          </div>
        </div>
      </template>


        <v-spacer/>


        <!--Logout-->
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn @click="onLogout"
                       icon
                       color="white"
                       v-bind="attrs"
                       v-on="on">
                    <v-icon dark>mdi-logout</v-icon>
                </v-btn>
            </template>
            <span>Logout</span>
        </v-tooltip>

    </v-app-bar>
</template>

<script>

import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";

export default {
    created() {
        console.log("Header created")
    },

    computed: {
      redactorReady() {
        return this.$store.state["redactor-store"]?.isInitReady === true;
      },

      isRedactorRoute() {
        return this.$route.path.startsWith("/m-redactor");
      },

      configUID() {
        return this.getGetterValue("getConfigUID");
      },

      globalUID() {
        return this.getGetterValue("getGlobalUID");
      },

      mapID() {
        const map = this.getGetterValue("getMapKind");
        return map?.code ?? null;
      },

        // getAppPermission() {
        //     //return this.$store.getters["permissions-store/getAppPermission"];
        //     return PermissionsStoreUtils.getAppPermission();
        // },
    },
    // watch: {
    //     getAppPermission(newValue, oldValue) {
    //         console.log("iii Listener: ", newValue, oldValue)
    //     },
    // },

    methods: {
      navTabs() {
          return [
            { label: "Profiles", to: "/m-profiles", icon: "mdi-account-multiple", disabled: this.P_USERS_TAB() },
            { label: "Configs", to: "/m-configs", icon: "mdi-cog", disabled: this.P_CONFIG_TAB() },
            { label: "Localizations", to: "/m-localization", icon: "mdi-web", disabled: this.P_LOCALIZATION_TAB() },
            { label: "Packages", to: "/m-packages", icon: "mdi-package-variant", disabled: this.P_PACKAGE_TAB() },
            { label: "Maps", to: "/m-maps", icon: "mdi-grid", disabled: this.P_MAP_TAB() },
            { label: "Inbox", to: "/m-inbox", icon: "mdi-email-outline", disabled: this.P_INBOX_TAB() },
            { label: "A/B Testing", to: "/m-audiences", icon: "mdi-chart-donut", disabled: this.P_AB_TAB() },
            { label: "Deploy", to: "/m-deploy", icon: "mdi-bird", disabled: this.P_DEPLOY_TAB() },
            { label: "Cache", to: "/m-cache", icon: "mdi-cached", disabled: this.P_CACHE_TAB() },
            { label: "Info", to: "/m-info", icon: "mdi-information-outline", disabled: this.P_INFO_TAB() },
            { label: "Permissions", to: "/m-permissions", icon: "mdi-lock-outline", disabled: this.P_PERMISSION_TAB() },
            { label: "UiUtils", to: "/m-uiutils", icon: "mdi-palette-outline", disabled: this.P_UIUTILS_TAB() },
            { label: "Utils", to: "/m-utils", icon: "mdi-domain", disabled: this.P_UTILS_TAB() }
          ];
        },

        getGetterValue(name) {
          const getter = this.$store.getters[`redactor-store/${name}`];

          return this.redactorReady && typeof getter === "function" ? getter() : null;
        },

        // aaa(){
        //     console.log(PermissionsStoreUtils.getAppPermission())
        //     this.$forceUpdate()
        // },
        P_USERS_TAB(){return !PermissionsStoreUtils.getPermission(this.uid(), PermissionsStoreUtils.USERS_TAB.id)},
        P_CONFIG_TAB(){return !PermissionsStoreUtils.getPermission(this.uid(), PermissionsStoreUtils.CONFIG_TAB.id)},
        P_LOCALIZATION_TAB(){
            return true;
            //return !PermissionsStoreUtils.getPermission(this.uid(), PermissionsStoreUtils.LOCALIZATION_TAB.id)
        },
        P_PACKAGE_TAB(){return !PermissionsStoreUtils.getPermission(this.uid(), PermissionsStoreUtils.PACKAGE_TAB.id)},
        P_MAP_TAB(){return !PermissionsStoreUtils.getPermission(this.uid(), PermissionsStoreUtils.MAP_TAB.id)},
        P_INBOX_TAB(){return !PermissionsStoreUtils.getPermission(this.uid(), PermissionsStoreUtils.INBOX_TAB.id)},
        P_INFO_TAB(){return !PermissionsStoreUtils.getPermission(this.uid(), PermissionsStoreUtils.INFO_TAB.id)},
        P_CACHE_TAB(){return !PermissionsStoreUtils.getPermission(this.uid(), PermissionsStoreUtils.CACHE_TAB.id)},
        P_DEPLOY_TAB(){return !PermissionsStoreUtils.getPermission(this.uid(), PermissionsStoreUtils.DEPLOY_TAB.id)},
        P_PERMISSION_TAB(){return !PermissionsStoreUtils.getPermission(this.uid(), PermissionsStoreUtils.PERMISSION_TAB.id)},
        P_AB_TAB(){return !PermissionsStoreUtils.getPermission(this.uid(), PermissionsStoreUtils.AB_TAB.id)},
        P_UIUTILS_TAB(){return false},
        P_UTILS_TAB(){return false},
        uid(){
            return PermissionsStoreUtils.getMyUserUid()
        },
      async onLogout() {
        try {
          await this.$confirm("Are you sure?");
          await this.$store.dispatch("auth/signOut");
          this.$notify({ text: "Logout successfully.", type: "success" });

          await this.$router.replace({name: "login"});
        } catch (err) {
          if (err) {
            this.$notify({ title: "Logout failed.", text: err, type: "error" });
          }
        }
      },
    }
}
</script>

<style scoped lang="scss">
.ac {
  &__header {
    &-info {
      display: flex;
      flex-direction: column;
      font-size: 10px;
      gap: 2px;
      margin-left: 10px;

      &-item {
        display: flex;

        &-title {
          display: flex;
          gap: 4px;
          opacity: 0.5;
          user-select: none;
        }

        > span {
          font-weight: 700;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>